{
  "lib_calendar": {
    "appointment-cancellation-dialog": {
      "buttons": {
        "back": "Zurück",
        "cancel": "Termin stornieren",
        "close": "Schliessen",
        "next": "Weiter"
      },
      "text": {
        "title": "Stornierung des Termins",
        "description": "Können Sie uns mehr darüber sagen, warum Sie den Termin nicht mehr wahrnehmen können?",
        "appointment-cancelled-successfully": "Der Termin wurde erfolgreich storniert!",
        "block_customer": "Möchten Sie diesen Kunden sperren?",
        "message_to_customer": "Nachricht an den Kunden",
        "no": "NEIN",
        "no_show": "Kunde ist nicht erschienen",
        "not_show_up": "Dieser Kunde ist in der Vergangenheit bereits zu {{ total }} Termin(en) nicht erschienen.",
        "not_show_up_first_time": "Dies ist das erste Mal, dass dieser Kunde nicht erschienen ist.",
        "reason": "Ihr Grund",
        "reason-better-deal": "Ich habe ein besseres Angebot gefunden",
        "reason-mistake": "Ich habe meine Meinung geändert oder versehentlich gebucht",
        "reason-other": "Andere Gründe",
        "reason-salon-asked-to-cancel": "Der Salon hat mich gefragt, ob ich den Termin absagen kann",
        "reason-unforeseen-circumstance": "Aufgrund unvorhergesehener Umstände konnte ich den Termin nicht wahrnehmen",
        "yes": "JA"
      }
    },
    "appointment-chat-box": {
      "text": {
        "chat-with": "Chatten mit {{name}}",
        "customer": "Kunden",
        "message": "Ihre Nachricht",
        "salon": "Salon"
      }
    },
    "appointment-confirmation-dialog": {
      "buttons": {
        "cancel": "Abbrechen",
        "confirm-and-book": "Bestätigen und buchen",
        "confirm-and-update": "Bestätigen und aktualisieren"
      },
      "text": {
        "title": "Terminbestätigung",
        "book-successfully": "Ihr Termin wurde erfolgreich gebucht",
        "update-successfully": "Ihr Termin wurde erfolgreich aktualisiert"
      }
    },
    "appointment-details": {
      "text": {
        "serve-by-staff": "Bedienung durch {{staff}}",
        "staff_selected_by_customer": "Die Mitarbeiter wurde vom Kunden ausgewählt",
        "total": "Gesamt"
      }
    },
    "appointment-details-card": {
      "buttons": {
        "checkin": "CHECK IN"
      },
      "text": {
        "appointment-canceled-by-salon": "Termin wurde vom Salon abgesagt",
        "appointment-canceled-by-you": "Termin wurde von Ihnen abgesagt",
        "status": "Status"
      }
    },
    "appointment-details-dialog": {
      "buttons": {
        "back": "Zurück",
        "edit": "Termin ändern"
      },
      "text": {
        "appointment_history": "Terminhistorie",
        "edit_profile": "Profil bearbeiten",
        "more_about_customer": "Mehr über diesen Kunden",
        "Visit history": "Besuchshistorie"
      }
    },
    "appointment-details-page": {
      "buttons": {
        "cancel": "Termin stornieren"
      },
      "text": {
        "creation_time": "Erstellungszeitpunkt",
        "last_update": "Letzte Aktualisierung"
      }
    },
    "appointment-form": {
      "text": {
        "customer-selection": "Kundenauswahl",
        "note": "Anmerkung",
        "rwg_appointment_hint": "Google Terminservice ist nicht editierbar",
        "service-selection": "Auswahl der Dienstleistungen",
        "staff-cannot-serve-any-hint": "Das ausgewählte Personal kann keine ausgewählte Dienstleistung bedienen. Bitte überlegen Sie, ob Sie ein anderes Personal auswählen möchten!",
        "staff-cannot-serve-all-hint": "Das ausgewählte Personal kann nicht alle ausgewählten Dienstleistungen bedienen. Einige von ihnen werden von einem anderen Personal bedient!",
        "staff_selected_by_customer": "Die Mitarbeiter wurde vom Kunden ausgewählt",
        "staff-selection": "Personalauswahl"
      }
    },
    "appointment-form-dialog": {
      "text": {
        "create_new_appointment": "Neuen Termin buchen",
        "edit_appointment": "Termin ändern"
      },
      "buttons": {
        "book": "BUCHEN",
        "close": "Zurück",
        "save": "Speichern"
      }
    },
    "appointment-history-dialog": {
      "text": {
        "appointment_history": "Aktuell gesehene Termine",
        "empty_history": "Der Verlauf der Terminansicht ist leer",
        "last_seen": "Zuletzt gesehen"
      }
    },
    "appointment-table": {
      "buttons": {
        "view": "Ansehen"
      },
      "text": {
        "all": "Alle",
        "customer": "Kunde",
        "date": "Datum",
        "service": "Dienstleistung",
        "staff": "Mitarbeiter",
        "status": "Status"
      }
    },
    "available-date-selection-by-month": {
      "text": {
        "not-available": "Nicht verfügbar. Bitte wählen Sie ein anderes Monat aus!"
      }
    },
    "available-date-selection-by-serie": {
      "text": {
        "date_range": "Zeitraum",
        "end_time": "Endzeit",
        "from_date": "Startdatum",
        "start_time": "Startzeit",
        "to_date": "Enddatum",
        "repeated_week_day": "Wiederholung an Wochentagen",
        "repeated_week_day_required": "Bitte mindestens einen Wochentag auswählen"
      }
    },
    "available-date-selection-form": {
      "text": {
        "date_selection": "Auswahl des Datums",
        "repeat_settings": "Wiederholungseinstellungen",
        "unable_to_block": "Es wird nichts geblockt, weil der Salon geschlossen ist oder es bereits andere Termine/Blocker an ausgewählten Tagen gibt"
      }
    },
    "available-slot-selection-by-date": {
      "text": {
        "afternoon": "NACHMITTAG",
        "evening": "ABEND",
        "morning": "VORMITTAG",
        "not-available": "Nicht verfügbar. Bitte wählen Sie ein anderes Datum aus!"
      }
    },
    "available-slot-selection-by-week": {
      "text": {
        "not-available": "Nicht verfügbar. Bitte wählen Sie eine andere Woche aus!"
      }
    },
    "available-slot-selection-form": {
      "buttons": {
        "date-view": "Datumsansicht",
        "week-view": "Wochenansicht"
      },
      "text": {
        "date-time-selection": "Datums und Uhrzeit",
        "date-time-selection-hint": "Bitte wählen Sie mindestens eine Dienstleistung aus",
        "slot_tact": "Zeitintervall für Buchung",
        "slot_tact_example": {
          "5": "z.B. 09:00, 09:05, 09:10, 09:15, 09:20, usw.",
          "15": "z.B. 09:00, 09:15, 09:30, 09:45, 10:00, usw.",
          "30": "z.B. 09:00, 09:30, 10:00, 10:30, 11:00, usw.",
          "60": "z.B. 09:00, 10:00, 11:00, 12:00, 13:00, usw."
        }
      }
    },
    "blocker-deletion-dialog": {
      "buttons": {
        "delete": "Löschen"
      },
      "text": {
        "title": "Löschung des Blockers",
        "delete_confirmation": "Sind Sie sicher, dass Sie diesen Blocker löschen wollen? Diese Aktion kann nicht rückgängig gemacht werden.",
        "delete_single_blocker_in_series": "Nur diesen Blocker löschen",
        "delete_series_blocker": "Alle Blocker in dieser Serie löschen",
        "delete_successfully": "Erfolgreich gelöscht"
      }
    },
    "blocker-details-card": {
      "text": {
        "belong_to_series_blocker": "Dieser Blocker ist ein Element eines Serienblockers"
      }
    },
    "blocker-details-dialog": {
      "text": {
        "creation_time": "Erstellungszeitpunkt",
        "last_update": "Letzte Aktualisierung"
      },
      "buttons": {
        "back": "Zurück",
        "edit": "Blocker ändern",
        "delete": "Blocker stornieren"
      }
    },
    "blocker-form": {
      "text": {
        "all_day": "Für den ganzen Tag blockieren",
        "duration": "Dauer",
        "off": "AUS",
        "on": "EIN",
        "reason": "Beschreibung",
        "reason_placeholder": "bspw. Grund für Blocker",
        "series_blocker": "Serienblocker",
        "staff-selection": "Personalauswahl"
      }
    },
    "blocker-form-dialog": {
      "text": {
        "blocker_updated": "Blocker wurde erfolgreich aktualisiert",
        "create_new_blocker": "Neuen Blocker erstellen",
        "edit_blocker": "Blocker ändern",
        "new_blocker_created": "Neuer Blocker wurde erfolgreich erstellt",
        "new_serie_blocker_created": "Neuer Serienblocker wurde erfolgreich erstellt"
      },
      "buttons": {
        "close": "Zurück",
        "create": "Erstellen",
        "save": "Speichern"
      }
    },
    "business-notification-dialog": {
      "buttons": {
        "close": "Zurück"
      },
      "text": {
        "no_notification": "Keine Benachrichtigungen seit {{ day }} Tagen",
        "notification": "Benachrichtigung",
        "staff": "Mitarbeiter"
      }
    },
    "date-picker": {
      "current": {
        "agenda": "Diese Woche",
        "day": "Heute",
        "month": "Dieser Monat",
        "week": "Diese Woche"
      }
    },
    "floating-buttons": {
      "buttons": {
        "new_appointment": "Neuer Termin",
        "new_blocker": "Neuer Blocker"
      }
    },
    "quick-update-appointment-dialog": {
      "buttons": {
        "cancel": "Abbrechen",
        "confirm": "Bestätigen"
      },
      "text": {
        "original_appointment": "Ursprünglicher Termin",
        "original_blocker": "Ursprünglicher Blocker",
        "staff": "Mitarbeiter",
        "start_time": "Datum und Uhrzeit",
        "update_unavailable": "Der gewünschte Zeitraum ist nicht verfügbar!",
        "updated_confirmation": "Aktualisierungsbestätigung",
        "updated_successfully": "Erfolgreich aktualisiert!"
      }
    },
    "tool_bar": {
      "buttons": {
        "more": "Mehr",
        "view_appointment_history": "Aktuell gesehene Termine",
        "view_cancelled_appointment": "Abgesagte Termine anzeigen"
      },
      "view_mode": {
        "agenda": "Agenda-Ansicht",
        "day": "Tagesansicht",
        "month": "Monatsansicht",
        "week": "Wochenansicht"
      }
    }
  }
}
